import PageWrapper from 'app/shared/components/PageWrapper/PageWrapper';
import { CookieDashboard } from 'app/containers/CookieDashboard/CookieDashboard';
import { PageId } from 'app/shared/components/PageWrapper/providers/PageProvider/hooks/usePageId/usePageId';

const CookieDashboardPage = props => (
  <PageWrapper pageId={PageId.COOKIE_DASHBOARD} {...props}>
    <CookieDashboard />
  </PageWrapper>
);

export default CookieDashboardPage;
